/**
 * Where CUBE AI (the header icon and the panel Router.tsx mounts) exists: pre-production
 * environments only, and never on the full-page chat itself, on share links — a logged-in user
 * opening one still gets the RECIPIENT experience (QA r3 3b) — or on PDF-export renders.
 */
export function isCubeAiAvailable(pathname: string): boolean {
  const env = process.env.REACT_APP_ENV;
  if (!env || !["qa", "development", "staging"].includes(env)) return false;
  return !pathname.startsWith("/ai/chat") && !pathname.startsWith("/share/") && !pathname.includes("pdfExport");
}
